import React, { useState, useEffect } from "react";
import classnames from "classnames";
import BackgroundVideo from "../components/Background-Video";
import BackButton from "../partials/Back-Button";
import {motion} from "framer-motion";
import Videos from "../video/101160_SCS_Interactive_Sc1_4K_10s_V3.mp4"

const CustomerOffice = () => {
  const [activeDot, setActiveDot] = useState("");
  const [dotOneX, setDotOneX] = useState();
  const [dotOneY, setDotOneY] = useState();
  const [blobOneX, setBlobOneX] = useState();
  const [blobOneY, setBlobOneY] = useState();
  const [dotTwoX, setDotTwoX] = useState();
  const [dotTwoY, setDotTwoY] = useState();
  const [blobTwoX, setBlobTwoX] = useState();
  const [blobTwoY, setBlobTwoY] = useState();

  const getPosition = () => {
    const dotOne = document.getElementById("dotOne").getBoundingClientRect();
    const dotOneTop = dotOne.top;
    const dotOneLeft = dotOne.left;

    setDotOneX(dotOneLeft + 21.5);
    setDotOneY(dotOneTop + 21.5);

    const blobOne = document.getElementById("blobOne").getBoundingClientRect();
    const blobOneTop = blobOne.top;
    const blobOneLeft = blobOne.left;

    setBlobOneX(blobOneLeft);
    setBlobOneY(blobOneTop);

    const dotTwo = document.getElementById("dotTwo").getBoundingClientRect();
    const dotTwoTop = dotTwo.top;
    const dotTwoLeft = dotTwo.left;

    setDotTwoX(dotTwoLeft + 21.5);
    setDotTwoY(dotTwoTop + 21.5);

    const blobTwo = document.getElementById("blobTwo").getBoundingClientRect();
    const blobTwoTop = blobTwo.top;
    const blobTwoLeft = blobTwo.left;

    setBlobTwoX(blobTwoLeft);
    setBlobTwoY(blobTwoTop);
  };

  useEffect(() => {
    getPosition();
  }, []);

  return (
      <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="w-screen h-[calc(100vh-172px)] relative top-[172px] left-0">
        <BackButton backurl="/connected-laptop" />
        <BackgroundVideo
            fullscreen
            video={Videos}
        />
        <div className="w-screen h-[calc(100vh-172px)] relative">
          <div className=" bg-opacity-50 backdrop-blur-md bg-white w-[600px] 2xl:w-[950px]  py-7 px-9 2xl:py-14 2xl:px-[59px]  rounded-3xl relative left-10 top-5 mr-auto zoom-8">
            <h1 className="font-semibold uppercase text-dell-blue font-proxima-nova text-lg 2xl:text-[25px] 2xl:leading-[30px] pb-3">
              CUSTOMER OFFICE
            </h1>
            <p className="font-proxima-nova text-[#444444] text-xl 2xl:text-[30px] 2xl:leading-[37px] font-thin">
              Monetize your 5G investment and add users to your network by empowering the mobile workforce on Dell connected laptops.
            </p>
          </div>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 1 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <line
                x1={dotOneX}
                y1={dotOneY}
                x2={blobOneX}
                y2={blobOneY}
                stroke="#444444"
                strokeDasharray="15 15"
            />
          </svg>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 2 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <line
                x1={dotTwoX}
                y1={dotTwoY}
                x2={blobTwoX}
                y2={blobTwoY}
                stroke="#FFFFFF"
                strokeDasharray="15 15"
            />
          </svg>

          <div className="edge-dots absolute w-screen h-[calc(100vh-172px)] top-0 grid grid-cols-5 grid-rows-3">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div className="relative flex justify-end items-center">
              <div
                  id="dotOne"
                  className="dot absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] right-20 bg-[#6E2585] border-2 cursor-pointer"
                  onMouseEnter={() => setActiveDot(1)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(1)}
                  onKeyDown={() => setActiveDot("")}
                  tabIndex={0}
              ></div>
              <div
                  id="blobOne"
                  className={classnames(
                      "absolute right-32 bottom-20 px-12 text-center flex flex-col justify-center items-center rounded-full bg-[#6E2585] text-white min-w-[300px] h-[300px] transition-all duration-300 ",
                      activeDot === 1
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Connectivity:
                </p>
                <p className="font-proxima-nova text-[20px] leading-[24px] font-thin">
                  A connected<br/>laptop provides<br/>always-on, reliable,<br/>secure connectivity.
                </p>
              </div>
            </div>
            <div></div>
            <div className="relative flex justify-center items-center">
              <div
                  id="dotTwo"
                  className="dot absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] bg-[#6E2585] border-2 cursor-pointer"
                  onMouseEnter={() => setActiveDot(2)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(2)}
                  onKeyDown={() => setActiveDot("")}
                  tabIndex={0}
              ></div>
              <div
                  id="blobTwo"
                  className={classnames(
                      "absolute bottom-24 right-32 px-12 text-center flex flex-col justify-center items-center rounded-full bg-[#6E2585] text-white min-w-[360px] h-[360px] transition-all duration-300",
                      activeDot === 2
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Collaboration:
                </p>
                <p className="font-proxima-nova text-[20px] leading-[24px] font-thin">
                  Remote workers are able to access virtual demos, presentations and collaborate with remote team members.
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
  );
};

export default CustomerOffice;
